module.exports = __webpack_public_path__ + "img/history_panda.c5259d4e.svg";